// import { CALL_API } from '../../middleware/api';
import { CALL_INTAKE_V2_API } from '../../middleware/intakeV2Api';

export const GET_CONTACTS_REQUEST = 'GET_CONTACTS_REQUEST';
export const GET_CONTACTS_SUCCESS = 'GET_CONTACTS_SUCCESS';
export const GET_CONTACTS_FAILURE = 'GET_CONTACTS_FAILURE';

// export const getClientContacts = () => {
//   return {
//     [CALL_API]: {
//       types: [GET_CONTACTS_REQUEST, GET_CONTACTS_SUCCESS, GET_CONTACTS_FAILURE],
//       authenticated: true,
//       endpoint: 'Client/GetClientContacts',
//       method: 'GET',
//       options: {
//         isClientSpecific: true,
//         isDivisionSpecific: true,
//       },
//     },
//   };
// };

export const getClientContacts = (clientId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CONTACTS_REQUEST, GET_CONTACTS_SUCCESS, GET_CONTACTS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizationFile/${clientId}/clientContacts`,
      method: 'GET',
    },
  };
};